/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type b2b_v1_advisor_holding_reports_HoldingsReportSettings = {
    delete_report_after?: number;
    enable_manual_accounts?: boolean;
    hide_error_details?: boolean;
    is_advisor_required?: boolean;
    redirect_on_connect?: boolean;
    report_data?: boolean;
    report_view?: b2b_v1_advisor_holding_reports_HoldingsReportSettings.report_view;
};
export namespace b2b_v1_advisor_holding_reports_HoldingsReportSettings {
    export enum report_view {
        SIMPLE = 'simple',
        DETAILED_VIEW = 'detailed_view',
        ALLOCATIONS_AND_POSITIONS = 'allocations_and_positions',
    }
}

